import { useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Card, CardContent, Box, Skeleton, Button } from "@mui/material";
import { useScriptMode } from "../../contexts/ScriptModeContext";
import { useGetGroupStatsQuery } from "../../api/managementApi";
import DateRangePicker from "./components/DateRangePicker";
import StatsSummaryCards from "./components/StatsSummaryCards";
import MemberStatsTable from "./components/MemberStatsTable";
import LabelBreakdownChart from "./components/LabelBreakdownChart";
import ConnectionState from "../../components/ui/ConnectionState";

function pad(n) { return String(n).padStart(2, "0"); }
function isoLocal(d) { return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`; }

function defaultRange() {
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth(), 1);
  return { start: isoLocal(start), end: isoLocal(now) };
}

export default function ManagedGroupStatsPage() {
  const { groupId } = useParams();
  const { t } = useScriptMode();
  const [range, setRange] = useState(defaultRange());

  const valid = !!range.start && !!range.end && range.start <= range.end;
  const { data, isLoading, isFetching, isError, error, refetch } = useGetGroupStatsQuery(
    { groupId, startDate: range.start, endDate: range.end },
    { skip: !valid }
  );

  const userStats = data?.data?.userStats || [];

  return (
    <div className="max-w-5xl mx-auto flex flex-col gap-5 px-4 md:px-0">
      <Link to={`/uygulama/yonetim/${groupId}`} className="text-terakkiPrimary text-sm">
        {t("manage_stats_back")}
      </Link>

      <h1 className="text-3xl font-Bold text-terakkiPrimary">
        {t("manage_stats_title")}
      </h1>

      <Card>
        <CardContent>
          <DateRangePicker value={range} onChange={setRange} />
        </CardContent>
      </Card>

      {isLoading || isFetching ? (
        <Box display="grid" gridTemplateColumns={{ xs: "1fr", sm: "repeat(3, 1fr)" }} gap={2}>
          <Skeleton variant="rectangular" height={84} />
          <Skeleton variant="rectangular" height={84} />
          <Skeleton variant="rectangular" height={84} />
        </Box>
      ) : isError ? (
        <ConnectionState
          error={error}
          onRetry={refetch}
          retrying={isFetching}
          message={t("manage_stats_load_error")}
        />
      ) : (
        <>
          <StatsSummaryCards userStats={userStats} />
          <Card>
            <CardContent>
              <LabelBreakdownChart userStats={userStats} />
            </CardContent>
          </Card>
          <Card>
            <CardContent>
              <MemberStatsTable userStats={userStats} />
            </CardContent>
          </Card>
        </>
      )}

      <Box>
        <Button component={Link} to={`/uygulama/yonetim/${groupId}`} variant="text">
          {t("manage_stats_back")}
        </Button>
      </Box>
    </div>
  );
}
